<template>
  <div>
    <div class="animationFix">
      <slot />
    </div>
  </div>
</template>
<script>
  export default {}
</script>
<style type="text/css" scoped>
.animationFix {
  overflow: hidden;
  height: 100%;
}
</style>